import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingCounter = 0;
  loading = new BehaviorSubject(false);

  constructor() {}

  startLoading() {
    this.loadingCounter++;
    if (this.loadingCounter === 1) {
      this.loading.next(true);
    }
  }

  endLoading() {
    if (this.loadingCounter > 0) {
      this.loadingCounter--;
      if (this.loadingCounter === 0) {
        this.loading.next(false);
      }
    }
  }
}
